<template>
  <el-table-column
    prop="invoice_number"
    sortable="custom"
    label="Számlaszám"
    min-width="200"
    fixed
  >
    <template slot-scope="scope">
      <el-tooltip
        v-if="scope.row.related_invoice"
        class="item"
        effect="dark"
        :content="`Kapcsolódó számla: ${scope.row.related_invoice.invoice_number}`"
        placement="top-start"
      >
        <i class="el-icon-connection"></i>
      </el-tooltip>
      <div
        v-if="scope.row.invoice_number"
        style="display: inline-block;"
      >
        <receipt-link
            :id="scope.row.id"
            :label="scope.row.invoice_number"
            type="invoice"
        />
      </div>
      <div
        v-if="scope.row.is_expired"
        style="color: #F56C6C;"
      >
        Lejárt számla
      </div>
    </template>
  </el-table-column>
</template>

<script>
import ReceiptLink from '../../../utils/ReceiptLink';

export default {
  components: { ReceiptLink },
  propName: 'invoice_number',
};
</script>
